import { http } from '../utils/http';

export const userLoginApi = async ({ password, email }) => {
  try {
    return await http.post('/Auth/login', { password, email });
  } catch (error) {}
};
export const checkIsLoginIn = (data) => {
  return new Promise((resolve) => {
    if (data) {
    } else {
      resolve(false);
    }
  });
};

export const forgotPassword = async (email) => {
  return await http.get('/Auth/forgot-password', {
    params: { email },
  });
};

export const logout = async () => {
  return await http.post('/Auth/logout');
};
